module.exports = __webpack_public_path__ + "img/iglu2.738b2242.jpg";